<template>
  <mb-panel v-if="displayStepper">
    <mb-section>
      <mb-stepper :selected="activeStep">
          <mb-step :label="$i18n.t('stepper.step1.text')" :clickable="disableClick"/>
          <mb-step :class="[ activeStep > 1 ? 'is-lastactive' : null ]" :label="$i18n.t('stepper.step2.text')" :clickable="disableClick"/>
       </mb-stepper>
    </mb-section>
  </mb-panel>    
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "stepper",
  data() {
    return {
      FIRST_STEP: 1,
      COMPLETED: 3
    };
  },
  computed: {
    activeStep() {
      return this.$route.name === 'ActivationRequest' ?  this.FIRST_STEP : this.COMPLETED;
    },    
    disableClick() {
      return true;
    },    
    displayStepper() {
      return this.$route.name === 'ActivationRequest' || this.$route.name === 'ActivationResponse' || this.$route.name === 'ActivationCode'?  true : false;
    },
  },
};
</script>